<template>
  <div>
    <Banner heading="Staff Portal Notifications"
            v-if="$vuetify.breakpoint.mdAndUp"
    />
    <Dashboard />
    <Alert
      v-if="displayAlert"
      show-alert
      :type="this.$store.getters.alert.type"
      :title="this.$store.getters.alert.message"
      :position="$vuetify.breakpoint.xsOnly ? 'top-center' : 'bottom-left'"
      :alert-class="'notificationAlert'"
      :timeout="-1"
    />
  </div>
</template>

<script>
// @ is an alias to /src
import Dashboard from '@/components/staffPortal/Dashboard.vue';
import { Banner} from '@nswdoe/doe-ui-core';
import Alert from "@/components/Alert";

export default {
  name: 'home',
  components: {
    Dashboard,
    Banner,
    Alert
  },
  computed: {
    displayAlert() {
      return this.$store.getters.showAlert && this.$store.getters.alert.message !== '';
    }
  }
}
</script>

<style lang="scss" scoped>
.notificationAlert {
  min-width: 800px !important;
}
</style>
